import Icon from '@/components/atoms/icon/icon';
import styles from './calendar-button.module.scss';

export interface CalendarButtonProps {
  /** The icon to insert */
  icon?: IconName;
}

const CalendarButton = ({ icon, ...rest }: CalendarButtonProps) => {
  return (
    <div {...rest} className={styles.component} role="img">
      {icon && <Icon name={icon} size={24} />}
    </div>
  );
};

CalendarButton.displayName = 'CalendarButton';

export default CalendarButton;
